import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { getUrlParam, getClientCredentials } from './tools/tools';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const devCredentials = {
  api_url: process.env.REACT_APP_API_URL,
  oauth_client_id: process.env.REACT_APP_OAUTH_CLIENT_ID,
  app_url: process.env.REACT_APP_APP_URL,
  purecloud_region: process.env.REACT_APP_PURECLOUD_REGION,
  showQueueBypass: (process.env.REACT_APP_SHOWQUEUEBYPASS === "true"),
  tokenDurationSeconds: (process.env.REACT_APP_PURECLOUD_TOKEN_TIMEOUT ? process.env.REACT_APP_PURECLOUD_TOKEN_TIMEOUT : 86400),
  purecloudOrg: process.env.REACT_APP_PURECLOUD_ORG
}

const setReloadTime = (tokenDurationSeconds: any) => {
    // console.log('Token experiation time in seconds: ', tokenDurationSeconds);
    setTimeout(() => {
        console.log('Authorization session expired. Reloading app.');
        window.location.reload();
    }, ((tokenDurationSeconds ? tokenDurationSeconds : 24*60*60) * 1000) - 5000);
}

/**
 * Logs into Genesys and reders app if successfull.
 * @param environment Genesys environment/location. For ref. visit https://developer.genesys.cloud/api/rest/.
 * @param pcOauthClientId Genesys Client Id generated by oAuth.
 * @param redirURL Redirect URL for Genesys Verification.
 * @param clientId Inflow Client Id generated by Multitenant.
 * @param purecloud_region Genesys Region Name.
 * @param logo Client logo saved in Multitenant.
 * @param purecloudOrg Genesys Organization name.
 * @param tokenDurationSeconds Genesys token experiation time in seconds.
 */
const login = (environment: any, pcOauthClientId: any, redirURL: any, clientId: any, purecloud_region: any, logo: any, purecloudOrg: any, tokenDurationSeconds: any) => {
    // console.log('environment: ', environment);
    // console.log(pcOauthClientId, `${redirURL}?caid=${clientId}`);
    setReloadTime(tokenDurationSeconds);
    const client = (window as any).platformClient.ApiClient.instance;
    client.setEnvironment(environment);
    client.loginImplicitGrant(pcOauthClientId, `${redirURL}?caid=${clientId}`)
    .then(() => {     // Login successfully
        ReactDOM.render(
            <BrowserRouter>
                <App pcRegion={ purecloud_region } clientAccessId={ clientId } logo={ logo } clientOrg={ purecloudOrg } pcOauthClientId={ pcOauthClientId }/>
            </BrowserRouter>
            , document.getElementById('root'));
    })
    .catch((err: any) => {
        // Handle failure response
        console.log('Error calling loginImplicitGrant');
        console.log(err);
    });
}

/**
 * Renders app.
 */
const renderApp = () => {
    if ((window as any).platformClient) {
        var clientId = getUrlParam('caid','Empty');
        // When in dev environment (see .env), use environment values to login and render app
        if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
            login(devCredentials.api_url,
                devCredentials.oauth_client_id,
                devCredentials.app_url,
                clientId,
                devCredentials.purecloud_region,
                {logo: null, logoImageType: null},
                devCredentials.purecloudOrg,
                devCredentials.tokenDurationSeconds);
        }   
        else {
            getClientCredentials(clientId)
            .then((res: any) => {
                var clientDetails = res.data;
                if (clientDetails.length > 0) {
                    // console.log(clientDetails);
                    var ca = clientDetails[0];
                        login(ca.api_url, ca.oauth_client_id, ca.app_url, clientId, ca.purecloud_region, {logo: ca.logo, logoImageType: ca.logoImageType}, ca.clientOrg, ca.tokenDurationSeconds);
                } else {
                    console.error('Access to app is denied. Please contact your Inflow Representative.');
                }
            })
            .catch((err: any) => {
            // Handle failure response
            console.log('Error getting Client Credentials..');
            console.log(err);
            });
        }
    }
    else
        setInterval(renderApp, 5000);      // When window.platformClient is null, retry render in 5 seconds
}

renderApp();
// reportWebVitals();

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
